import React, { useState } from "react";

interface MaintenancePageProps {
  password: string;
  onAdminAccess: () => void;
}

const Maintenance: React.FC<MaintenancePageProps> = ({ password: correctPassword, onAdminAccess }) => {
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const handlePasswordSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === correctPassword) {
      onAdminAccess();
      setShowPasswordPrompt(false);
      setPassword("");
      setPasswordError("");
    } else {
      setPasswordError("Грешна парола!");
      setPassword("");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-100 via-white to-green-200 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg border border-green-200 p-8 max-w-lg w-full text-center">
        {!showPasswordPrompt ? (
          <>
            <div className="mb-8">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-green-200 rounded-full mb-6">
                <svg className="w-10 h-10 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </div>
              <h1 className="text-4xl font-bold text-gray-800 mb-4">PCCenter</h1>
              <p className="text-lg text-gray-600 mb-2">
                Работим върху подобрения. Ще бъдем обратно скоро.
              </p>
            </div>
            
            <div className="space-y-6">
              <div className="bg-green-100 rounded-lg p-4">
                <div className="flex items-center justify-center space-x-3 text-green-800">
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-green-400 border-t-green-700"></div>
                  <span className="font-medium">Активно работим...</span>
                </div>
              </div>
              
              <div className="text-center">
                <button
                  onClick={() => setShowPasswordPrompt(true)}
                  className="text-sm text-green-700 hover:text-green-800 underline hover:no-underline font-medium"
                >
                  Админ достъп
                </button>
              </div>
            </div>
          </>
        ) : (
          <form onSubmit={handlePasswordSubmit} className="space-y-6">
            <div className="text-center mb-6">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-green-200 rounded-full mb-4">
                <svg className="w-8 h-8 text-green-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h2 className="text-2xl font-bold text-gray-800">Админ достъп</h2>
            </div>
            
            <div>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Въведете парола"
                className="w-full px-4 py-3 border-2 border-green-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400 focus:border-green-500 text-center text-lg"
                autoFocus
              />
            </div>
            
            {passwordError && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                <p className="text-red-600 text-sm font-medium">{passwordError}</p>
              </div>
            )}
            
            <div className="flex space-x-3">
              <button
                type="submit"
                className="flex-1 bg-green-700 hover:bg-green-800 text-white font-medium py-3 px-4 rounded-lg transition-all duration-200 transform hover:scale-105"
              >
                Влез
              </button>
              <button
                type="button"
                onClick={() => {
                  setShowPasswordPrompt(false);
                  setPassword("");
                  setPasswordError("");
                }}
                className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-lg transition-colors"
              >
                Назад
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default Maintenance;